<template>
  <div>
    <div class="tools-banner" style="
        background: linear-gradient(
          to bottom,
          #1262a7 0%,
          #0e4a87 25%,
          #0b3a72 60%,
          #062852 100%
        );
      ">
            <div class="inner-bound">
              <h1 class="white-color">{{ t("tools.name") }}</h1>
              <div class="hot-tools">
                <div v-for="(item, index) in plainTm('tools.hotTools.items')" :key="index">
                  
                  <div>
                    <NuxtLink :to="localePath(item.link)">{{ item.title }}</NuxtLink>
                    <p>{{ item.desc }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div class="inner-bound" style="padding-bottom: .8rem; padding-top: .17rem">
              <div class="tools">
                  <h2 class="" v-animate="'fadeInUp'">{{ t('tools.sslTools.title') }}</h2>
                  <p class="mb30" v-animate="'fadeInUp'">{{ t('tools.sslTools.desc') }}</p>
                  <div class="tool-list">
                     <div v-for="(item, index) in plainTm('tools.sslTools.items')" :key="index" class="base-card" v-animate="'fadeInUp'">
                      <NuxtLink :to="localePath(item.link)">
                          <div class="hot-title"><h4 >{{ item.title }}</h4><span class="hot" v-if="item.hot">HOT</span></div>
                          <p v-html="item.desc"></p>
                          <span class="right-arrow">&#8594;</span>
                       </NuxtLink>
                      </div>
                  </div>
              </div>
          
              <div class="tools">
                  <h2 class="" v-animate="'fadeInUp'">{{ t('tools.dnsTools.title') }}</h2>
                  <p class="mb30" v-animate="'fadeInUp'">{{ t('tools.dnsTools.desc') }}</p>
                  <div class="tool-list">
                      <div v-for="(item, index) in plainTm('tools.dnsTools.items')" :key="index" class="base-card" v-animate="'fadeInUp'">
                        <NuxtLink :to="localePath(item.link)">
                          <div class="hot-title"><h4 >{{ item.title }}</h4><span class="hot" v-if="item.hot">HOT</span></div>
                          <p v-html="item.desc"></p>
                          <span class="right-arrow">&#8594;</span>
                          </NuxtLink>
                      </div>
                      
                  </div>
              </div>
          
              <div class="tools">
                  <h2 class="" v-animate="'fadeInUp'">{{ t('tools.CSTools.title') }}</h2>
                  <p class="mb30" v-animate="'fadeInUp'">{{ t('tools.CSTools.desc') }}</p>
                  <div class="tool-list">
                      <div class="base-card" v-animate="'fadeInUp'">
                          <div ><a href="https://www.cloudflare.com"  class="hot-title" target="_blank" rel="nofollow"><h4>{{ t('tools.CSTools.items[0].title') }} </h4><span class="hot">HOT</span></a></div>
                          <p v-animate="'fadeInUp'">{{ t('tools.CSTools.items[0].desc') }}</p>
                          <span class="right-arrow">&#8594;</span>

                      </div>
                  </div>
              </div>
          </div>
  </div>
</template>

<script setup>
import { onMounted, nextTick, computed } from 'vue'

const { t } = useI18n()
const { plainTm } = usePlainTm();
usePageSeo({
  title: t("tools.title"),
  description: t("tools.description"),
  bodyId: "tools-page",
})

</script>
